/**
 * test if calendar event is from Google Calendar
 */
const isGCalEvent = (arg: Record<string, any>) => arg.timeslot_id === null;
export default isGCalEvent;
